var exports = {
  "k": "xa15a2ab7--f75555--container",
};

module.exports = exports;
